angular
  .module("digitalLeasing.module")

  .component("acceptance", {
    templateUrl: "ng/components/digitalLeasing/acceptance/acceptance.view.html",
    bindings: {
      model: "=",
      privacy: "<",
      reteVendita: "<",
      snapshot: '<',
      portalRunned: "<"
    },
    controllerAs: "AcceptanceCtrl",
    controller: function DigitalLeasingController($digitalService, $portalService) {
      var self = this;

      self.supportModel = {
        isPreventivo: false,
        isInfo: false,
        privacy: null,
        downloadList: null,
        preventivePrinted: false
      }

      self.$digitalService = $digitalService;
      self.contactsValidity = false;
      self.customerContactsOk = false;
      self.bankContactsOk = false;

      self.$onInit = function () {
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
        self.portalService = $portalService;

        self.model = self.model;

        console.info("initialized model as: ", self.model);

        self.appCustomer = {
          cf: self.model.financialCustomer.metadata.riUserG.cf,
          piva: self.model.financialCustomer.metadata.riUserG.piva,
          formaGiuridica: self.model.financialCustomer.metadata.riUserG.formaGiuridica,
          ndg: self.model.financialCustomer.metadata.riUserG.ndg
        }
        self.restIsPending = true;
        self.showInSnapshot = false;
        if (self.snapshot) {
          self.printOptions = self.model.leasingData.preventivo.printOptions;
          self.checkContactsVisibility();
        }
      };

      self.checkPreventivePrint = function (isPreventivePrinted) {
        if (isPreventivePrinted) {
          self.supportModel.preventivePrinted = true;
        }

      }

      self.checkDownloadInfo = function (validation) {
        if (validation) {
          self.supportModel.isInfo = true;
        }
        self.check();
      }

      self.checkDownloadPreventivo = function (validation) {
        if (validation) {
          self.supportModel.isPreventivo = true;
        } else {
          self.supportModel.isPreventivo = false;
        }
        self.check();
      }

      self.onPrivacyOk = function (privacy) {
        self.supportModel.privacy = privacy;
        self.checkPrivacy = true;
        self.check();
      }

      self.onPrivacyNotOk = function (privacy) {
        self.checkPrivacy = false;
        self.check();
      }

      self.giveAcceptanceDownloadList = function (downloadList) {
        self.supportModel.downloadList = downloadList;
      }

      self.check = function () {

        if ($portalService.isAra()) {

          if ((self.supportModel.isPreventivo && self.supportModel.isInfo && self.checkPrivacy && self.contactsValidity) ||
            (self.supportModel.isPreventivo && self.supportModel.isInfo && self.model.financialCustomer.metadata.privacy.valid && self.contactsValidity)) {
            self.model.financialCustomer.metadata.checkDownloads = true;
          } else {
            self.model.financialCustomer.metadata.checkDownloads = false;
          }

        } else if ($portalService.isAru()) {

          if (self.supportModel.isPreventivo && self.supportModel.isInfo && self.contactsValidity) {
            self.model.financialCustomer.metadata.checkDownloads = true;
          } else {
            self.model.financialCustomer.metadata.checkDownloads = false;
          }

        }


      }

      self.$onChanges = function (changes) {
        console.log("model changed! :", changes);
      };

      self.exportRiferimenti = function (printOptions) {
        if (printOptions) {
          self.restIsPending = false;
        }
        self.printOptions = printOptions;
        if (printOptions.riferimenti) {
          var index = self.printOptions.riferimenti.findIndex(function (element) {
            return element.id == "VENDOR"
          })
          if (index >= 0) {
            self.printOptions.riferimenti[index].id = "BANCA";
          }
        }
        self.validityCustomer();

      }

      self.validityBank = function (validity) {
        self.bankContactsOk = validity;
        self.checkContacts();
      }

      self.validityCustomer = function (validity) {
        self.customerContactsOk = validity;
        self.checkContacts();
      }
      self.checkContacts = function () {
        if (self.printOptions && self.printOptions.showContacts && self.printOptions.showBankContacts) {
          self.contactsValidity =
            self.bankContactsOk &&
            self.customerContactsOk;
        } else if (self.printOptions.showContacts && !self.printOptions.showBankContacts) {
          self.contactsValidity = self.customerContactsOk;
        } else {
          self.contactsValidity = true;
        }
        self.check();
      }

      self.updatePrivacy = function (privacy) {
        self.model.financialCustomer.metadata.privacy = privacy;
        self.check();
      }

      self.checkContactsVisibility = function () {
        if (self.model.leasingData.preventivo.contatti && self.model.leasingData.preventivo.contatti.riferimenti && self.model.leasingData.preventivo.contatti.riferimenti.length) {
          self.model.leasingData.preventivo.contatti.riferimenti.forEach(function (element) {
            if ((element.cf && element.cf != "") ||
              (element.description && element.description != "") ||
              (element.email && element.email != "") ||
              (element.id && element.id != "") ||
              (element.ndg && element.ndg != "") ||
              (element.telefono && element.telefono != "")) {
              self.showInSnapshot = true;
              self.printOptions.showBankContacts = true;
            } else {
              self.showInSnapshot = false;
            }
          })
        }
      }
    }
  });